function swiper() {
	
	this.bx = 0;
	this.by = 0;
	
	this.inX = 0;
	this.inY = 0;
	
	this.ldist = 0;
	this.cdist = 0;
	this.dist = 0;

	this.distFromCenterX = 0;
	this.distFromCenterY = 0;
	this.centerX = 0;
	this.centerY = 0;
	this.deadCenter = 0;

	this.distMidPoint = {};

	this.sweeping = false;
	this.resizing = false;
	
	this.lastTap = null;
	this.doubleTap = false;
	this.alwaysSweep = false;

	var self = this;
	this.iv = setInterval(function() {
		self.inX *= 0.95;
		self.inY *= 0.91;
	}, 1000 / 60);

	this.start = function(t) {
		var x;
		var y;
		var ct;

		if (t.points.length > 1) {
			/*
			x = t.points[0].pageX - t.points[1].pageX;
			y = t.points[0].pageY - t.points[1].pageY;
		
			this.cdist = Math.sqrt(x * x, y * y);
			this.ldist = this.cdist;
			*/

			this.dist = 0;
			this.resizing = true;
			this.firstresize = true;
		}
		
		this.bx = t.pageX;
		this.by = t.pageY;

		if (isNaN(this.bx)) this.bx = 0;
		if (isNaN(this.by)) this.by = 0;

		this.originX = this.bx;
		this.originY = this.by;

		this.inX = 0;
		this.inY = 0;

		this.doubleTap = false;
		
		if (this.lastTap != null) {
			ct = Date.now();
			if (ct - this.lastTap < 200 && !this.sweeping && !this.zooming) this.doubleTap = true;
		}

		this.lastTap = Date.now();

		this.sweeping = true;
	};
	
	this.move = function(t) {
		var x;
		var y;
		
		this.resizing = false;
		
		if (this.sweeping || this.alwaysSweep) {
			if (t.points.length > 1) {

				x = t.points[0].pageX - t.points[1].pageX;
				y = t.points[0].pageY - t.points[1].pageY;
		
				var cur = Math.sqrt(x * x + y * y);

				if (this.firstresize) {
					this.firstresize = false;
					this.ldist = cur;
				} else {
					this.ldist = this.cdist;
				}
				this.cdist = cur;
				
				if (this.ldist > -1) {
					this.dist = (this.cdist - this.ldist);
					this.distMidPoint = {
						"x": t.points[0].pageX + t.points[1].pageX - t.points[0].pageX,
						"y": t.points[0].pageY + t.points[1].pageY - t.points[0].pageY,
					};
				}
				else this.dist = 0;
				
				this.resizing = true;
				
				this.inX = 0;
				this.inY = 0;
				
			} else {
				this.ldist = -1;
				this.cdist = -1;
			}
						
			x = t.pageX;
			y = t.pageY;

			if (isNaN(x)) x = this.bx;
			if (isNaN(y)) y = this.by;

			this.distFromCenterX = x - this.centerX;
			this.distFromCenterY = y - this.centerY;
			if (Math.abs(this.distFromCenterX) < this.centerX * this.deadCenter) this.distFromCenterX = 0;
			else this.distFromCenterX = this.distFromCenterX > 0 ? this.distFromCenterX - this.centerX * this.deadCenter: this.distFromCenterX + this.centerX * this.deadCenter;

			if (Math.abs(this.distFromCenterY) < Math.abs(this.centerY) * this.deadCenter) this.distFromCenterY = 0;
			else this.distFromCenterY = this.distFromCenterY > 0 ? this.distFromCenterY - this.centerY * this.deadCenter: this.distFromCenterY + this.centerY * this.deadCenter;

			this.inX *= 0.7;
			this.inY *= 0.7;
			this.inX -= (x - this.bx) * 0.03;
			this.inY += (y - this.by) * 0.02;
	//		this.inX = -(x - this.bx) * 0.003;
	//		this.inY = (y - this.by) * 0.002;
				
			if (this.inX > 20) this.inX = 20;
			if (this.inX < -20) this.inX = -20;
				
			if (this.inY > 20) this.inY = 20;
			if (this.inY < -20) this.inY = -20;				
			
			this.bx = x;
			this.by = y;
		} else {
			if (t.points.length > 1) {
				x = t.points[0].pageX - t.points[1].pageX;
				y = t.points[0].pageY - t.points[1].pageY;
				
				this.ldist = this.cdist;
				this.cdist = Math.sqrt(x * x + y * y);
				
				if (this.ldist > -1) this.dist = (this.cdist - this.ldist);
				else this.dist = 0;
				
				this.resizing = true;
				//$("#info").html(x + ", " + y);
				
				//$("#info").html(this.dist);
				
				this.inX = 0;
				this.inY = 0;				
			}

			x = t.pageX;
			y = t.pageY;

			if (isNaN(x)) x = this.bx;
			if (isNaN(y)) y = this.by;

			this.distFromCenterX = x - this.centerX;
			this.distFromCenterY = y - this.centerY;
			if (Math.abs(this.distFromCenterX) < this.centerX * this.deadCenter) this.distFromCenterX = 0;
			else this.distFromCenterX = this.distFromCenterX > 0 ? this.distFromCenterX - this.centerX * this.deadCenter: this.distFromCenterX + this.centerX * this.deadCenter;

			if (Math.abs(this.distFromCenterY) < Math.abs(this.centerY) * this.deadCenter) this.distFromCenterY = 0;
			else this.distFromCenterY = this.distFromCenterY > 0 ? this.distFromCenterY - this.centerY * this.deadCenter: this.distFromCenterY + this.centerY * this.deadCenter;

			this.bx = x;
			this.by = y;
		}
	};
	
	this.end = function() {
		this.ldist = -1;
		this.cdist = -1;
		this.dist = 0;

		this.sweeping = false;
		this.resizing = false;
	};
	
	this.distance = function() {
		var r = this.dist;
		this.dist *= 0.5;

		return r;
	}
	
	this.inertiaX = function() {
		//this.inX *= 0.95;
		return this.inX;
	}
	
	this.inertiaY = function() {
		//this.inY *= 0.91;
		return this.inY;
	}

	this.isScrolling = function() {
		if (Math.abs(this.inX) > 0.4 || Math.abs(this.inY) > 0.4) return true;
		return false;
	};

	this.isClick = function() {
		if (Math.abs(this.originX - this.bx) > 5 || Math.abs(this.originY - this.by) > 5) return false;
		return true;
	};

	this.setCenter = function(cx, cy, dead) {
		this.centerX = cx;
		this.centerY = cy;
		this.deadCenter = dead;
	}
}